export default __webpack_public_path__ + "static/media/higher_icon_clipboard_mono.3a53923d.svg";